import { useMemo } from 'react';
import useGithubOrgs from './useGithubOrgs';

const useGithubOrgsOptions = (integration, selectedValues) => {
  const isOnPrem = integration?.is_on_prem;
  const { githubOrgs, isLoading } = useGithubOrgs(integration);
  const onPremOrgs = selectedValues.map(value => ({ name: value }));

  const disabledValues = isOnPrem ? [...selectedValues] : [];

  const options = useMemo(
    () =>
      (isOnPrem ? onPremOrgs : githubOrgs)
        .map(org => {
          const orgName = org?.name;
          if (!orgName) return false;
          return {
            value: orgName,
            displayValue: orgName,
            searchableValue: orgName
          };
        })
        .filter(Boolean),
    [githubOrgs.length]
  );

  return { options, disabledValues, isLoading };
};

export default useGithubOrgsOptions;
